import { SxProps, Theme } from '@mui/system';

const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },

  video: {
    width: '100%',
    maxHeight: 320,
    borderRadius: 1,
    backgroundColor: 'common.black',
    objectFit: 'cover',
    // Mirror the front camera preview so it behaves like a mirror; the
    // captured photo keeps the camera's real orientation.
    transform: 'scaleX(-1)',
  },

  error: {
    fontSize: 12,
    color: 'common.error',
  },

  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 1,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
